import React from 'react';
import { MessageSquareIcon } from 'lucide-react';
const updates = [{
  id: 1,
  author: 'Robert Chen',
  role: 'COO',
  avatar: 'RC',
  color: '#1E6FA0',
  title: 'Operations Update: New Processing Workflow',
  date: 'Feb 15, 2025',
  content: "We're rolling out a streamlined processing workflow that will reduce our average close time by 3 days. The new system integrates directly with Encompass and automates the initial document review phase. Training sessions will be held next week."
}, {
  id: 2,
  author: 'Jennifer Walsh',
  role: 'CEO & Founder',
  avatar: 'JW',
  color: '#1A2B3C',
  title: '2024 Year in Review',
  date: 'Jan 5, 2025',
  content: 'What a year! $1B in volume, 124 team members, and a 4.8 client satisfaction score. We navigated a challenging rate environment by focusing on what we do best: exceptional service and speed. Thank you all for your hard work.'
}, {
  id: 3,
  author: 'Jennifer Walsh',
  role: 'CEO & Founder',
  avatar: 'JW',
  color: '#1A2B3C',
  title: 'Holiday Message',
  date: 'Dec 20, 2024',
  content: "As we close out 2024, I want to thank each of you for your dedication. Please take time to rest and recharge with your families over the holidays. You've earned it."
}];
export function CeoUpdates() {
  return <div style={{
    maxWidth: 800,
    margin: '0 auto'
  }} data-id="element-71">
      <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      marginBottom: 32
    }} data-id="element-72">
        <div style={{
        width: 48,
        height: 48,
        borderRadius: 12,
        background: '#EBF5FB',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }} data-id="element-73">
          <MessageSquareIcon size={24} color="#2B8DC4" data-id="element-74" />
        </div>
        <div data-id="element-75">
          <h2 style={{
          fontSize: 26,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 3px',
          fontStyle: 'italic',
          letterSpacing: '-0.04em'
        }} data-id="element-76">
            Leadership Updates
          </h2>
          <p style={{
          fontSize: 13,
          color: '#5A6A8A',
          margin: 0
        }} data-id="element-77">
            Messages from Swift leadership
          </p>
        </div>
      </div>

      {/* Featured Latest Message */}
      <div style={{
      background: '#FFFFFF',
      borderRadius: 16,
      padding: '32px',
      border: '1px solid #E4EAF6',
      borderTopWidth: 4,
      borderTopColor: '#1A2B3C',
      boxShadow: '0 4px 16px rgba(13,27,42,0.06)',
      marginBottom: 24
    }} data-id="element-78">
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        marginBottom: 24
      }} data-id="element-79">
          <div style={{
          width: 56,
          height: 56,
          borderRadius: 12,
          background: '#1A2B3C',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
          fontWeight: 900,
          color: 'white',
          transform: 'skewX(-4deg)'
        }} data-id="element-80">
            JW
          </div>
          <div data-id="element-81">
            <div style={{
            fontSize: 16,
            fontWeight: 900,
            color: '#1A2B3C',
            fontStyle: 'italic',
            letterSpacing: '-0.01em'
          }} data-id="element-82">
              Jennifer Walsh
            </div>
            <div style={{
            fontSize: 13,
            color: '#5A6A8A',
            fontWeight: 500
          }} data-id="element-83">
              CEO & Founder
            </div>
          </div>
          <div style={{
          marginLeft: 'auto',
          fontSize: 12,
          fontWeight: 700,
          color: '#A0AECB'
        }} data-id="element-84">
            March 1, 2025
          </div>
        </div>

        <h3 style={{
        fontSize: 24,
        fontWeight: 900,
        color: '#1A2B3C',
        margin: '0 0 16px',
        fontStyle: 'italic',
        letterSpacing: '-0.02em'
      }} data-id="element-85">
          Q1 2025: Building Momentum
        </h3>

        <div style={{
        fontSize: 15,
        color: '#1A2B3C',
        lineHeight: 1.7,
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }} data-id="element-86">
          <p style={{
          margin: 0
        }} data-id="element-87">
            Team, I'm incredibly proud of what we've accomplished together.
            Crossing $1 billion in annual volume puts us in the top 5% of
            independent mortgage companies nationally.
          </p>
          <p style={{
          margin: 0
        }} data-id="element-88">
            But what I'm most proud of is HOW we got here — through integrity,
            teamwork, and an unwavering commitment to our clients.
          </p>
          <p style={{
          margin: 0
        }} data-id="element-89">
            As we move into Q1, our focus is on three things: expanding our
            product offerings, investing in technology, and continuing to
            develop our people. I believe our best days are ahead. Let's make
            2025 our strongest year yet.
          </p>
          <p style={{
          margin: 0,
          fontWeight: 700,
          fontStyle: 'italic'
        }} data-id="element-90">
            — Jennifer
          </p>
        </div>
      </div>

      {/* Previous Updates */}
      <h3 style={{
      fontSize: 16,
      fontWeight: 900,
      color: '#1A2B3C',
      margin: '0 0 16px',
      fontStyle: 'italic',
      letterSpacing: '-0.02em'
    }} data-id="element-91">
        Previous Updates
      </h3>
      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 16
    }} data-id="element-92">
        {updates.map(update => <div key={update.id} style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '24px',
        border: '1px solid #E4EAF6',
        borderTopWidth: 3,
        borderTopColor: update.color,
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
      }} data-id="element-93">
            <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          marginBottom: 16
        }} data-id="element-94">
              <div style={{
            width: 40,
            height: 40,
            borderRadius: 10,
            background: update.color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 14,
            fontWeight: 900,
            color: 'white',
            transform: 'skewX(-4deg)'
          }} data-id="element-95">
                {update.avatar}
              </div>
              <div data-id="element-96">
                <div style={{
              fontSize: 14,
              fontWeight: 900,
              color: '#1A2B3C',
              fontStyle: 'italic'
            }} data-id="element-97">
                  {update.author}
                </div>
                <div style={{
              fontSize: 12,
              color: '#5A6A8A'
            }} data-id="element-98">
                  {update.role}
                </div>
              </div>
              <div style={{
            marginLeft: 'auto',
            fontSize: 11,
            fontWeight: 700,
            color: '#A0AECB'
          }} data-id="element-99">
                {update.date}
              </div>
            </div>
            <h4 style={{
          fontSize: 16,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 8px',
          fontStyle: 'italic',
          letterSpacing: '-0.01em'
        }} data-id="element-100">
              {update.title}
            </h4>
            <p style={{
          fontSize: 14,
          color: '#5A6A8A',
          margin: 0,
          lineHeight: 1.6
        }} data-id="element-101">
              {update.content}
            </p>
          </div>)}
      </div>
    </div>;
}